import { render, staticRenderFns } from "./AiTriageWhitelistedDomainsPanel.vue?vue&type=template&id=0548284a&scoped=true&"
import script from "./AiTriageWhitelistedDomainsPanel.vue?vue&type=script&lang=js&"
export * from "./AiTriageWhitelistedDomainsPanel.vue?vue&type=script&lang=js&"
import style0 from "./AiTriageWhitelistedDomainsPanel.vue?vue&type=style&index=0&id=0548284a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0548284a",
  null
  
)

export default component.exports